<template>

        <div class="clearfix news-listing-box smile-page">
        <div class="smilepage-intro-image" >
          <img src="../assets/img/previousprojectHero.png" alt="Intro Image"/>
        </div>
        
        <div class="timeline-page-header">
          <div class="timline-page-title">
          <h1> Previous Projects</h1>
          </div>
        </div>
          <div class="timeline-containter">
            <div v-if="loaded === false">
              <h4>Loading News.. Please wait..</h4>
            </div>
            <ul class="timeline-items" v-else-if="currentPageNews && currentPageNews.length > 0">
              <li v-for="newsItem in currentPageNews" :key="newsItem['.key']" class="timeline-item">
              <div class="timeline-content">
                <content-image :src="newsItem.TimelineIcon" :fieldClass="'responsive-TimelineIcon'"/>
                  <content-title :fieldClass="'timeline-title'" v-if="newsItem.Title" :text="newsItem.Title"/>
                  <content-body v-if="newsItem.IntroText" :fieldClass="'news-body'" :body="newsItem.IntroText"/>
                  <button type="submit" class="button is-info"  @click="callModal('add', newsItem)">Read More</button>
                  <!-- Modal -->
                  <modal class="modal" @close="showModal.add = false"  v-if="showModal.add" :kind="'timnelineItem'" :header="itemToShow.Title" :newsItem="itemToShow">
                  </modal>
                  <!-- <router-link :to="$route.path + '/' + (newsItem.slug ? newsItem.slug : newsItem['.key'])" class="btn is-small">Read more</router-link>-->
                </div>
              </li>
            </ul>
            <div v-else>
              No Timelines Found
            </div>
          </div>
        </div>
      </div>
</template>

<script>
import appHeader from '@/app/components/appHeader'
import appFooter from '@/app/components/appFooter'
import pagination from '@/app/components/pagination'
import Body from '@/app/fieldTemplates/Body.vue'
import Title from '@/app/fieldTemplates/Title.vue'
import Image from '@/app/fieldTemplates/Image.vue'
import Tags from '@/app/fieldTemplates/Tags.vue'
import Categories from '@/app/fieldTemplates/Categories.vue'
import { contentsRef, routesRef } from '@/admin/firebase_config/index'
import contentFetch from '@/admin/mixins/contentFetch'
import categoryFilter from '@/admin/mixins/categoryFilter'
import modal from '@/admin/components/shared/Modal'
import _ from 'lodash'

const stringContains = (search, stringArr) => {
  let strContains = false
  stringArr.forEach(string => {
    if (string.toLowerCase().includes(search.toLowerCase())) strContains = true
  })
  return strContains
}

export default {
  mixins: [contentFetch, categoryFilter],
  components: {
    appHeader,
    appFooter,
    pagination,
    contentBody: Body,
    contentTitle: Title,
    contentImage: Image,
    contentTags: Tags,
    contentCategories: Categories,
    modal:modal
  },
  firebase: {
    routes: routesRef,
    contents: {
      source: contentsRef,
      readyCallback: function () {
        console.log('hellow')
        this.loaded = true
      }
    }
  },
  data () {
    return {
      filter: {
        category: undefined,
        q: undefined,
        currentPage: 1
      },
      searchQuery: undefined,
      perPage: 4, // No of news per page
      loaded: false,
      showModal: { add: false},
      itemToShow:null
    }
  },
  watch: {
    // Update routes whenenver any filter paramters change
    filter: {
      handler: function () {
        this.updateRoute()
      },
      deep: true
    }
  },
  computed: {
   
    filteredNews () {
      const searchQuery = this.filter.q
      const category = this.filter.category
     
        return _.filter(this.news, function (o) {
          console.log(o);
          return (!searchQuery || (stringContains(searchQuery, o.title) || stringContains(searchQuery, o.subheadline)))
        })
    },
    currentPageNews () {
      // let pageNumber = Math.floor(this.filteredNews.length / this.perPage);
      // let lastPageContentNum;
    this.filteredNews.sort((a, b) => Number(b.Date)  -Number(a.Date));
    
      // if (this.filteredNews.length % this.perPage !== 0) {
      //   lastPageContentNum = this.filteredNews.length % this.perPage
      //   pageNumber += 1
      // }

      // if(this.filter.currentPage === 1) {
      //   return _.slice(this.filteredNews, this.filter.currentPage - 1, ((this.filter.currentPage - 1) + this.perPage))
      // } 
      // else if (this.filter.currentPage === pageNumber && lastPageContentNum) {
      //   return _.slice(this.filteredNews, ((this.filter.currentPage -1) * this.perPage), (((this.filter.currentPage -1) * this.perPage)) + lastPageContentNum)
      // } 
      // else {
      //   return _.slice(this.filteredNews, (this.filter.currentPage - 1) * this.perPage, (((this.filter.currentPage - 1) * this.perPage) + this.perPage))
      // }
      return this.filteredNews;
    }

  },
  mounted () {

  },
  methods: {
     callModal (type, newsItem) {
      switch (type) {
        case 'add':
        console.log(newsItem);
        this.itemToShow = newsItem;
          this.showModal.add = true
          break
        default:
          break
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/app/styles/index.scss';
.smilepage-intro-image{
  margin:auto;
  width:100%;
  max-width:1440px;
  display: flex;
}
.timeline-page-header{
  padding:20px;
  background: $color-smile-green;
}
.timline-page-title{
  color:white;
  padding:20px;
  text-align:center;
  font-size:24px;
  font-weight:600;
}
/* TIMELINE
–––––––––––––––––––––––––––––––––––––––––––––––––– */

.timeline-containter ul {
  // background-color:$color-smile-sand;
  // background: #456990;
  padding: 50px 0;
}

.timeline-item {
  list-style-type: none;
  position: relative;
  width: 6px;
  margin: 0 auto;
  padding-top: 50px;
  background: $color-smile-pink;
}

.timeline-item::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: inherit;
  background-color:$color-smile-green;
}

.timeline-item .timeline-content {
  position: relative;
  bottom: 0;
  // min-width: 90px;
  width:550px;
  padding: 15px;
  // color:white;
  background: white;
      border-radius: 13px;
      display: flex;
    // flex-direction: column;
    justify-content: center;
    flex-wrap: wrap;
    img{
      min-width: 250px;
    }
}
.title-container .timeline-title{
      font-size:24px;
      font-weight:600;
      text-align:center;
    }
.timeline-item .timeline-content::before {
  content: '';
  position: absolute;
  bottom: 7px;
  width: 0;
  height: 0;
  border-style: solid;
}

.timeline-item:nth-child(odd) .timeline-content {
  left: 45px;
}

.timeline-item:nth-child(odd) .timeline-content::before {
  left: -15px;
  border-width: 8px 16px 8px 0;
  border-color: transparent white transparent transparent;//change color
}

.timeline-item:nth-child(even) .timeline-content {
      left: -589px;
}

.timeline-item:nth-child(even) .timeline-content::before {
  right: -15px;
  border-width: 8px 0 8px 16px;
  border-color: transparent transparent transparent white;
}

time {
  display: block;
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 8px;
}


/* GENERAL MEDIA QUERIES
–––––––––––––––––––––––––––––––––––––––––––––––––– */
@media screen and (max-width: 1200px) {
  .timeline-item .timeline-content {
    width: 450px;
  }
  .timeline-item:nth-child(even) .timeline-content {
    left: -491px;
    /*250+45-6*/
  }
}
@media screen and (max-width: 1000px) {
  .timeline-item .timeline-content {
    width: 400px;
  }
  .timeline-item:nth-child(even) .timeline-content {
    left: -440px;
    /*250+45-6*/
  }
}

@media screen and (max-width: 900px) {
  .timeline-item .timeline-content {
    width: 254px;
  }
  .timeline-item:nth-child(even) .timeline-content {
    left: -289px;
    /*250+45-6*/
  }
}

@media screen and (max-width: 600px) {
  .timeline-item {
    margin-left: 20px;
  }
  .timeline-item .timeline-content {
    width: calc(100vw - 91px);
  }
  .timeline-item:nth-child(even) .timeline-content {
    left: 45px;
  }
  .timeline-item:nth-child(even) .timeline-content::before {
    left: -15px;
    border-width: 8px 16px 8px 0;
    border-color: transparent white transparent transparent;
  }
}
</style>